import React, {Component} from "react";
import ReactDOM from "react-dom"
import Icon from "../Icon";

import classes from "./styles.module.css";

class ContextMenu extends Component {
    constructor(props) {
        super(props);
        this.icon = props.icon;
        this.submenuRef = React.createRef();

        this.state = {
            isOpened: false,
            submenuStyle: null,
        };

        this.toggleState = this.toggleState.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.updatePlacement = this.updatePlacement.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, false);
    }

    handleClickOutside(e) {
        const node = ReactDOM.findDOMNode(this);
        const submenu = this.submenuRef.current;

        if ((!node || !node.contains(e.target)) && (!submenu || !submenu.contains(e.target))) {
            this.setState({
                isOpened: false,
                submenuStyle: null,
            });
        }
    }

    toggleState() {
        const willOpen = !this.state.isOpened;

        this.setState(
            {
                isOpened: willOpen,
                submenuStyle: null,
            },
            () => {
                if (willOpen) {
                    this.updatePlacement();
                }
            }
        );
    }

    updatePlacement() {
        const node = ReactDOM.findDOMNode(this);
        const submenu = this.submenuRef.current;

        if (!node || !submenu) return;

        const nodeRect = node.getBoundingClientRect();
        const submenuRect = submenu.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const edgeGap = 8;
        const menuGap = 4;
        const spaceBelow = viewportHeight - nodeRect.bottom;
        const spaceAbove = nodeRect.top;
        const opensUp = submenuRect.height + menuGap > spaceBelow && spaceAbove > spaceBelow;
        const maxLeft = Math.max(edgeGap, viewportWidth - submenuRect.width - edgeGap);
        const maxTop = Math.max(edgeGap, viewportHeight - submenuRect.height - edgeGap);
        const left = Math.min(Math.max(edgeGap, nodeRect.right - submenuRect.width), maxLeft);
        const preferredTop = opensUp ? nodeRect.top - submenuRect.height - menuGap : nodeRect.bottom + menuGap;
        const top = Math.min(Math.max(edgeGap, preferredTop), maxTop);

        this.setState({
            submenuStyle: {
                left: `${left}px`,
                top: `${top}px`,
                visibility: 'visible',
            },
        });
    }

    render() {
        const submenuStyle = this.state.submenuStyle || {left: 0, top: 0, visibility: 'hidden'};

        return (
            <div className={`${classes.Wrap} ${this.state.isOpened ? classes.Opened : ''}`}>
                <div onClick={this.toggleState}>
                    <Icon className={classes.icon} icon={this.icon} size={'18px'}/>
                </div>

                {this.state.isOpened &&
                    ReactDOM.createPortal(
                        <div
                            datatype='submenu'
                            ref={this.submenuRef}
                            className={classes.Submenu}
                            style={submenuStyle}
                        >
                            {this.props.children}
                        </div>,
                        document.body
                    )}
            </div>
        )
    }
}

export default ContextMenu;



// WEBPACK FOOTER //
// ./src/Components/Utils/ContextMenu/index.js